var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0013 7.70706C28.0013 7.11804 27.6149 6.59878 27.0506 6.42973L21.7173 4.82973C21.4673 4.75467 21.2007 4.75467 20.9506 4.82973L15.6173 6.42973C15.0536 6.59926 14.6678 7.11841 14.668 7.70706L14.668 14.4791C14.6683 15.0242 15.0004 15.5142 15.5066 15.7164L20.84 17.8497C21.1579 17.977 21.5127 17.977 21.8306 17.8497L27.164 15.7164C27.6696 15.5137 28.0012 15.0238 28.0013 14.4791V7.70706Z",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6611 6.81836L21.3345 8.71569L15.0078 6.81836",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 8.66602L21.334 17.9993",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6673 21.1775C34.6673 20.8998 34.4952 20.6512 34.2353 20.5535L29.5686 18.8041C29.4177 18.7476 29.2515 18.7476 29.1006 18.8041L24.434 20.5535C24.1741 20.6512 24.002 20.8998 24.002 21.1775L24.002 26.3028C24.002 26.5551 24.1444 26.7858 24.37 26.8988L29.0366 29.2321C29.2242 29.3259 29.445 29.3259 29.6326 29.2321L34.2993 26.8988C34.5248 26.7858 34.6673 26.5551 34.6673 26.3028V21.1775Z",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5252 20.7676L29.3332 22.7142L24.1426 20.7676",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 22.666V29.3327",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.334 23.0094C21.3341 22.4353 20.9667 21.9255 20.422 21.7441L13.7553 19.5214C13.4818 19.4304 13.1862 19.4304 12.9127 19.5214L6.24598 21.7441C5.70126 21.9255 5.33385 22.4353 5.33398 23.0094L5.33398 31.7548C5.33385 32.3289 5.70126 32.8387 6.24598 33.0201L12.9127 35.2428C13.1862 35.3339 13.4818 35.3339 13.7553 35.2428L20.422 33.0201C20.9667 32.8387 21.3341 32.3289 21.334 31.7548L21.334 23.0094Z",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0225 22.1523L13.3345 24.715L5.64648 22.1523",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 24.666L13.334 35.3327",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.6953a0df5fa6a35be002f76a312c8245.svg";
export { ForwardRef as ReactComponent };